import React, { useEffect, useState, useCallback } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, LineChart, Line } from 'recharts';
import axios from 'axios';
import moment from 'moment';
import styles from './ChartPreview.module.css';
import { useMediaQuery } from '@mui/material';
import { Auth } from 'aws-amplify';

const chartMargin = {
  top: 10,
  right: 10,
  left: -25,
  bottom: -10,
};

const legendWrapperStyle = {
  color: '#8884d8',
  fontSize: '14px',
  fontWeight: 'normal',
};

const ChartPreview = ({ startDate, endDate, dataType, location, onChartDataLoad = () => {} }) => {
  const [chartData, setChartData] = useState([]);
  const isLargeScreen = useMediaQuery('(min-width:600px)');

  const fetchData = useCallback(async (dataType) => {
    if (!startDate || !endDate || !dataType || !location) {
      return;
    }
    const formattedStartDate = moment(startDate).format('YYYY-MM-DD');
    const formattedEndDate = moment(endDate).format('YYYY-MM-DD');
    const url = `${process.env.REACT_APP_API_URL}/${dataType}?loc=${location}&start=${formattedStartDate}&end=${formattedEndDate}`;

    try {
      const accessToken = await Auth.currentAuthenticatedUser();
      const headers = {
        Authorization: accessToken.signInUserSession.idToken.jwtToken,
      };
      const response = await axios.get(url, { headers });
      setChartData(response.data);
    } catch (error) {
      console.error(error);
      setChartData([]);
    }
  }, [startDate, endDate, location]);

  useEffect(() => {
    fetchData(dataType);
  }, [dataType, fetchData]);

  useEffect(() => {
    if (chartData.length > 0) {
      onChartDataLoad(chartData);
    }
  }, [chartData, onChartDataLoad]);

  const chartWidth = isLargeScreen ? 660 : 350;

  let chart = null;
  if (chartData.length > 0) {
    if (dataType === 'visitors') {
      chart = (
        <div className={styles.outter_graph}>
        <LineChart className={styles.chart} width={chartWidth} height={300} data={chartData} margin={chartMargin}>
          <CartesianGrid strokeDasharray="4 4" horizontal={true} vertical={false}/>
          <XAxis
            dataKey="dt"
            stroke="white"
            tickFormatter={(tick) => new Date(tick).toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' })}
          />
          <YAxis
            stroke="white"
            tickFormatter={(tick) => Math.floor(tick)}
            width={65}
          />
          <Tooltip formatter={(value, name, props) => {
            const date = new Date(props.payload.dt);
            const formattedDate = `${date.toLocaleDateString('it-IT')} ${date.toLocaleTimeString('it-IT')}`;
            const valueString = `Valore: ${value}`;
            return [formattedDate, valueString];
          }} />
          <Legend wrapperStyle={legendWrapperStyle} payload={[{ value: 'Visitatori', type: 'circle', color: '#8884d8', id: 'max_passangers' }]} />
          <Line type="monotone" dataKey={dataType} stroke="#8884d8" dot={false} strokeWidth={1} />
        </LineChart></div>
      );
    } else if (dataType === 'flights') {
      chart = (
        <div className={styles.outter_graph}>
        <BarChart className={styles.chart} width={chartWidth} height={300} data={chartData} margin={chartMargin}>
        <CartesianGrid strokeDasharray="4 4" horizontal={true} vertical={false}/>          <XAxis
            dataKey="dt"
            stroke="white"
            tickFormatter={(tick) => new Date(tick).toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit' })}
          />
          <YAxis
            stroke="white"
            tickFormatter={(tick) => Math.floor(tick)}
          />
          <Tooltip formatter={(value, name, props) => {
            const date = new Date(props.payload.dt);
            const formattedDate = `${date.toLocaleDateString('it-IT')} ${date.toLocaleTimeString('it-IT')}`;
            const valueString = `Valore: ${value}`;
            return [formattedDate, valueString];
          }} />
          <Legend wrapperStyle={legendWrapperStyle} payload={[{ value: 'Voli', type: 'square', color: '#8884d8', id: 'max_passangers' }]} />
          <Bar dataKey={dataType} fill="#8884d8" />
        </BarChart></div>
      );
    } else if (dataType === 'cruises') {
      chart = (
        <div className={styles.outter_graph}>
        <BarChart className={styles.chart} width={chartWidth} height={300} data={chartData} margin={chartMargin}>
        <CartesianGrid strokeDasharray="4 4" horizontal={true} vertical={false}/>          <XAxis
            dataKey="dt"
            stroke="white"
            tickFormatter={(tick) => new Date(tick).toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit' })}
          />
          <YAxis
            dataKey='max_passangers'
            stroke="white"
            tickFormatter={(tick) => Math.floor(tick / 1000) + "k"}
          />
          <Tooltip formatter={(value, name, props) => {
            const date = new Date(props.payload.dt);
            const formattedDate = `${date.toLocaleDateString('it-IT')} ${date.toLocaleTimeString('it-IT')}`;
            const valueString = `Valore: ${value}`;
            return [formattedDate, valueString];
          }} />
          <Legend wrapperStyle={legendWrapperStyle} payload={[{ value: 'Capacità massima passeggeri', type: 'square', color: '#82ca9d', id: 'max_passangers' }]} />
          <Bar dataKey='max_passangers' fill="#82ca9d" />
        </BarChart></div>
      );
    }
  } else {
    chart = (
      <div className={styles.outter_graph}>
      <BarChart
          className={styles.chart}
          width={chartWidth}
          height={300}
          data={[]}
          margin={chartMargin}
      >
          <CartesianGrid strokeDasharray="4" />
          <XAxis dataKey="dt" stroke="white" />
          <YAxis stroke="white" />
          <Legend />
          <Bar dataKey={dataType} fill="#8884d8" />
          <text
              x="50%"
              y="50%"
              dominantBaseline="middle"
              textAnchor="middle"
              fill="#8884d8"
          >
              <tspan>Dati insufficienti.</tspan>
              <tspan x="50%" dy="1.2em">
                  Cambiare il periodo selezionato.
              </tspan>
          </text>
      </BarChart></div>
  );
}

  return (
    <div>
      <h2 className={styles.titleh2}>Anteprima dati</h2>
      {chart}
    </div>
  );
};

export default ChartPreview;